require('videogular');
require('./vg-overlay-play');

module.exports = 'com.2fdevs.videogular.plugins.overlayplay';



//////////////////
// WEBPACK FOOTER
// ./~/videogular-overlay-play/index.js
// module id = 79
// module chunks = 0